/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    Comment,
    CommentFromJSON,
    CommentToJSON,
    CommentWithVoteAllOf,
    CommentWithVoteAllOfFromJSON,
    CommentWithVoteAllOfToJSON,
    VoteOption,
    VoteOptionFromJSON,
    VoteOptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface CommentWithVote
 */
export interface CommentWithVote {
    /**
     * 
     * @type {string}
     * @memberof CommentWithVote
     */
    ideaId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentWithVote
     */
    commentId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentWithVote
     */
    parentCommentId?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentWithVote
     */
    childCommentCount: number;
    /**
     * Author of the comment. If null, comment is deleted
     * @type {string}
     * @memberof CommentWithVote
     */
    authorUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentWithVote
     */
    authorName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommentWithVote
     */
    authorIsMod?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommentWithVote
     */
    authorPic?: string;
    /**
     * 
     * @type {string}
     * @memberof CommentWithVote
     */
    authorPicUrl?: string;
    /**
     * 
     * @type {Date}
     * @memberof CommentWithVote
     */
    created: Date;
    /**
     * If set, comment was last edited at this time. If deleted, this is deleted time.
     * @type {Date}
     * @memberof CommentWithVote
     */
    edited?: Date;
    /**
     * If set, comment represents a merged postid
     * @type {string}
     * @memberof CommentWithVote
     */
    mergedPostId?: string;
    /**
     * Shows the title of the merged post, whereas content represent description of the post
     * @type {string}
     * @memberof CommentWithVote
     */
    mergedPostTitle?: string;
    /**
     * 
     * @type {Date}
     * @memberof CommentWithVote
     */
    mergedTime?: Date;
    /**
     * Comment content. If null, comment is deleted
     * @type {string}
     * @memberof CommentWithVote
     */
    content?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentWithVote
     */
    voteValue: number;
    /**
     * 
     * @type {VoteOption}
     * @memberof CommentWithVote
     */
    vote?: VoteOption;
}

export function CommentWithVoteFromJSON(json: any): CommentWithVote {
    return {
        'ideaId': json['ideaId'],
        'commentId': json['commentId'],
        'parentCommentId': !exists(json, 'parentCommentId') ? undefined : json['parentCommentId'],
        'childCommentCount': json['childCommentCount'],
        'authorUserId': !exists(json, 'authorUserId') ? undefined : json['authorUserId'],
        'authorName': !exists(json, 'authorName') ? undefined : json['authorName'],
        'authorIsMod': !exists(json, 'authorIsMod') ? undefined : json['authorIsMod'],
        'authorPic': !exists(json, 'authorPic') ? undefined : json['authorPic'],
        'authorPicUrl': !exists(json, 'authorPicUrl') ? undefined : json['authorPicUrl'],
        'created': new Date(json['created']),
        'edited': !exists(json, 'edited') ? undefined : new Date(json['edited']),
        'mergedPostId': !exists(json, 'mergedPostId') ? undefined : json['mergedPostId'],
        'mergedPostTitle': !exists(json, 'mergedPostTitle') ? undefined : json['mergedPostTitle'],
        'mergedTime': !exists(json, 'mergedTime') ? undefined : new Date(json['mergedTime']),
        'content': !exists(json, 'content') ? undefined : json['content'],
        'voteValue': json['voteValue'],
        
        'vote': !exists(json, 'vote') ? undefined : VoteOptionFromJSON(json['vote']),
    };
}

export function CommentWithVoteToJSON(value?: CommentWithVote): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'ideaId': value.ideaId,
        'commentId': value.commentId,
        'parentCommentId': value.parentCommentId,
        'childCommentCount': value.childCommentCount,
        'authorUserId': value.authorUserId,
        'authorName': value.authorName,
        'authorIsMod': value.authorIsMod,
        'authorPic': value.authorPic,
        'authorPicUrl': value.authorPicUrl,
        'created': value.created.toISOString(),
        'edited': value.edited === undefined ? undefined : value.edited.toISOString(),
        'mergedPostId': value.mergedPostId,
        'mergedPostTitle': value.mergedPostTitle,
        'mergedTime': value.mergedTime === undefined ? undefined : value.mergedTime.toISOString(),
        'content': value.content,
        'voteValue': value.voteValue,
        
        'vote': VoteOptionToJSON(value.vote),
    };
}


